module.exports = __webpack_public_path__ + "img/new-treatment-modal-desktop-en.6ae2408b.jpg";